import clsx from 'clsx'
import { memo } from 'react'

export const WidgetFrame = memo(({ children, className = '' }) => {
  return (
    <div className={clsx('box-border h-full w-full overflow-y-auto bg-white', className)}>
      {children}
    </div>
  )
})
